module.exports = __webpack_public_path__ + "static/mzdy-acdd5dd5d0da073b7d814bfa54df4aa9.png";